<script>

    import {cartTotalStore} from "../cart/cart-store.js";
    import {mediaUrlStore, publishConfigStore, tenantKeyStore} from "../core/app-store.js";
    import WidgetYandexBusiness from "../components/WidgetYandexBusiness.svelte";
    import DocsBlock from "../components/DocsBlock.svelte";
    import {t} from "../core/i18n/language-store.js";
    import {platformStore} from "./PlatformLabel/platform-store.js";
    import PlatformLabel from "./PlatformLabel/PlatformLabel.svelte";

</script>

<style>

    footer {
        min-height: 70vh;
        padding: 0 1rem;
    }

    .content {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        text-align: center;
        padding: 2rem 2rem;
    }

    .logo-container {

    }

    .logo-image {
        width: 40vw;
        height: 40vw;
        display: block;
        border-radius: 4px;
    }
    @media (min-width: 768px) {
        .logo-image {
            width: 100px;
            height: 100px;
        }
    }

    h2 {
        text-transform: uppercase;
        color: var(--accent);
        font-size: var(--fs-150);
        font-weight: 400;
    }
    @media (min-width: 768px) {
        h2 {
            font-size: 2.75rem;
        }
    }

    .dm-label {
        border-top: 1px solid var(--semi-transpagent-red);
        color: var(--secondary-text);
        text-align: center;
        padding: 1.5rem;
    }

    .cart-space {
        height: 5rem;
    }

    .yb-container {
        padding-top: 1.5rem;
    }

</style>

<footer class="layer-sections flex-column jc-center ai-center">

    <div class="content flex-fill">

        {#if $publishConfigStore.logoUrl}
            <div class="logo-container flex jc-center ai-center">
                <object class="logo-image"
                        data="{$mediaUrlStore}{$tenantKeyStore}{$publishConfigStore.logoUrl}"
                        type="image/png">
                    <img class="full-width full-height" loading="lazy"
                         src="./images/fallback-logo-image.svg"
                         alt={$publishConfigStore.restaurantName}>
                </object>
            </div>
        {/if}

        {#if $publishConfigStore.ybId}
            <div class="yb-container flex jc-center">
                <WidgetYandexBusiness
                        ybId={$publishConfigStore.ybId}
                        ybWidgetTheme={$publishConfigStore.ybWidgetTheme}
                />
            </div>
        {/if}

        <h2>{$publishConfigStore.restaurantName}</h2>

        {#if $publishConfigStore.restaurantAddress}
            <div>
                <div>
                    {$publishConfigStore.restaurantAddress}
                </div>

                <div>
                    {#if ($publishConfigStore.restaurantAddressLinkAction === 'yandex-maps' && $publishConfigStore.restaurantAddressLink)}
                        (<a href="{$publishConfigStore.restaurantAddressLink}" target="_blank" rel="nofollow noopener">{$t('footer.map')}</a>)
                    {:else if ($publishConfigStore.restaurantAddressLinkAction === 'geo' && $publishConfigStore.restaurantAddressGeo)}
                        <span class="hide-on-desktop">(<a href="geo:{$publishConfigStore.restaurantAddressGeo}" target="_blank" rel="nofollow noopener">{$t('footer.map')}</a>)</span>
                    {:else if ($publishConfigStore.restaurantAddressLinkAction !== 'none')}
                        (<a href="https://maps.google.com/?q={$publishConfigStore.restaurantAddress}" target="_blank" rel="nofollow noopener">{$t('footer.map')}</a>)
                    {/if}
                </div>
            </div>
        {/if}
    </div>

    <DocsBlock></DocsBlock>

    <PlatformLabel data={$platformStore}></PlatformLabel>

    {#if ($cartTotalStore?.count > 0)}
        <div class="cart-space"></div>
    {/if}
</footer>
